import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
const ShadowPanel = (props) => {
    return _jsx(_Fragment, { children: _jsx("div", { className: `flex justify-content-center shadow rounded bg-opacity-50 bg-light-subtle bg-gradient ${props.className}`, children: props.children }) });
};
export default ShadowPanel;
